import { render, staticRenderFns } from "./FilterRepotCH.vue?vue&type=template&id=482a55fe"
import script from "./FilterRepotCH.vue?vue&type=script&lang=js"
export * from "./FilterRepotCH.vue?vue&type=script&lang=js"
import style0 from "./FilterRepotCH.vue?vue&type=style&index=0&id=482a55fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports